webpackJsonp([14],{

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Topic: function Topic() {
      return __webpack_require__.e/* import() */(21/* duplicate */).then(__webpack_require__.bind(null, 96));
    }
  },
  data: function data() {
    return {
      tags: ['Electronic', 'Quantum', 'Atomic Physics', 'Exploration']
    };
  }
});

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('topic',{attrs:{"title":"Electronic tools for science - how I ended up building gear for atomic physics in Hong Kong.","speaker":"Sébastien Bourdeauducq","icon":"/2017/img/speaker/sebastien.png","venue":"LT 17","time":"16:45 - 17:30","tags":_vm.tags,"language":"English","live":"https://www.youtube.com/watch?v=w8OjJVXwoMc"}},[_c('p',{attrs:{"slot":"speaker"},slot:"speaker"},[_vm._v("\n    Sébastien is the founder and a director of M-Labs Ltd,\n    a small company designing software and hardware for physics laboratories worldwide.\n  ")]),_vm._v(" "),_c('p',{attrs:{"slot":"abstract"},slot:"abstract"},[_vm._v("\n    Modern physics experiments cannot take place without massive amounts of computer automation and data crunching.\n    In this talk, I will present the ARTIQ control system that we have been developing\n    and how it is used by researchers in quantum information and atomic physics.\n    I will also tell you how I got into this field, why it's exciting, and how you too can get involved.\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Electronic_vue__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f830fc5_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Electronic_vue__ = __webpack_require__(350);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Electronic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f830fc5_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Electronic_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// 14.c90836aae91c5dc585e6.js